import { render, staticRenderFns } from "./UsFlag.vue?vue&type=template&id=38099a31&scoped=true&"
import script from "./UsFlag.vue?vue&type=script&lang=js&"
export * from "./UsFlag.vue?vue&type=script&lang=js&"
import style0 from "./UsFlag.vue?vue&type=style&index=0&id=38099a31&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38099a31",
  null
  
)

export default component.exports